import {OnInit} from "@angular/core";
import {VacationVO} from "./InjectionVO";
import * as moment from "moment";
import {ParseFileVO} from "./exports";

export class BaseComponent implements OnInit {
  _file: File;
  get file() {
    return this._file;
  }
  set file(f: File) {
    this._file = f;
  }

  onParseFile: "ON_READ" | "DONE" | "FAILED" | null = null;
  validatiorColumns = {
    "A": {exec: Validatiors.Default},
    "B": {exec: Validatiors.Date},
    "C": {exec: Validatiors.Hours,required:true},
    "D": {exec: Validatiors.Hours,required:true},
    "E": {exec: Validatiors.Hours,required:false},
    "F": {exec: Validatiors.Hours,required:false},
    "G": {exec: Validatiors.Hours,required:false},
    "H": {exec: Validatiors.Hours,required:false},
    "I": {exec: Validatiors.Hours,required:false},
    "J": {exec: Validatiors.Hours,required:false},

/*    "G": {exec: Validatiors.Hours,required:true, specs: {$between: ['C', 'D'], $lt: ["H"]}},
    "H": {exec: Validatiors.Hours,required:true, specs: {$between: ['C', 'D'], $gt: ["G"]}},
    "I": {exec: Validatiors.Hours,required:true, specs: {$between: ['E', 'F'], $lt: ["J"]}},
    "J": {exec: Validatiors.Hours,required:true, specs: {$between: ['E', 'F'], $gt: ["I"]}},*/
    "K": {exec: Validatiors.Hours,required:false, specs: {$between: ['C', 'D'], $lt: ["L"]}},
    "L": {exec: Validatiors.Hours,required:false, specs: {$between: ['C', 'D'], $gt: ["K"]}},
    "M": {exec: Validatiors.Hours,required:false, specs: {$between: ['E', 'F'], $lt: ["N"]}},
    "N": {exec: Validatiors.Hours,required:false, specs: {$between: ['E', 'F'], $gt: ["M"]}},

    "O": {exec: Validatiors.Default},
/*    "L": {exec: Validatiors.Digit},
    "M": {exec: Validatiors.Default}*/
  }

  get headerKeys() {
    return Object.keys(this.validatiorColumns);
  }

  public breaks: Array<any> = ['NONE', '10:00', '15:00', '20:00', '25:00', '30:00'];

  public hours: Array<any> = [null].concat(new Array(24).fill(0).map((v, index) => {
    return (index < 10 ? '0' + index : index) + ':00';
  }));

  public hoursBreak: Array<any> = [];

  constructor() {
    this.hours.push("23:59")
    this.inHoursBreak();
  }

  ngOnInit() {
    this.inHoursBreak();
  }

  checkRowsValues(rows: Array<any>, index, hour: string, key: string) {
    const vacation1: any = rows[0];
    const vacation2: any = rows[1];
    if (index == 0) {
      switch (key) {
        case "end1":
          return !(vacation1.start1) || this.HhMmtoDate(hour) <= this.HhMmtoDate(vacation1.start1);
        case "start2":
          return !(vacation1.start1 && vacation1.end1) || this.HhMmtoDate(hour) < this.HhMmtoDate(vacation1.end1);
        case "end2":
          return !(vacation1.start1 && vacation1.end1 && vacation1.start2) || this.HhMmtoDate(hour) <= this.HhMmtoDate(vacation1.start2);
      }
    } else if (index == 1 && vacation2) {
      switch (key) {
        case "start1":
          return !(vacation1.end2) || this.HhMmtoDate(hour) < this.HhMmtoDate(vacation1.end2);
        case "end1":
          return !(vacation1.end2 && vacation2.start1) || this.HhMmtoDate(hour) <= this.HhMmtoDate(vacation2.start1);
        case "start2":
          return !(vacation2.start1 && vacation2.end1) || this.HhMmtoDate(hour) < this.HhMmtoDate(vacation2.end1);
        case "end2":
          return !(vacation2.start1 && vacation2.end1 && vacation2.start2) || this.HhMmtoDate(hour) <= this.HhMmtoDate(vacation2.start2);
      }
    }
    return false;
  }
  checkRowsValuesNew(rows: Array<any>, index, hour: string, key: string) {
    if (index == 0) {
      let vacation1 =  rows[0];
      switch (key) {
        case "end1":
          return vacation1.start1 && this.HhMmtoDate(hour) <= this.HhMmtoDate(vacation1.start1);
      }
    }
   else if (index>=1){
     let vacationCurrent = rows[index];
     let vacation_1 = rows[index-1];
      switch (key) {
        case "start1": return vacation_1.end1 && this.HhMmtoDate(hour) <= this.HhMmtoDate(vacation_1.end1);
        case "end1": return vacationCurrent.start1 && this.HhMmtoDate(hour) <= this.HhMmtoDate(vacationCurrent.start1);
      }
    }

    return false;
  }

  HhMmtoDate(m) {
    return new Date("2023-01-01 " + m);
  }

  setHour(vacation: VacationVO, key: string, value: string, event: any) {

    if (event.disabled) return;

    vacation[key] = value;
    if (["start1", "end1"].includes(key)) {
      if (vacation.start1 >= vacation.end1) {
        vacation.end1 = null;
      }
      if (vacation.start1 >= vacation.start2 || vacation.end1 >= vacation.start2) {
        vacation.start2 = null;
        vacation.end2 = null;
      }
    }

    if (["start2", "end2"].includes(key)) {
      if (!vacation.start1 || !vacation.end1) {
        vacation.start2 = '';
        vacation.end2 = '';
      }
      if (!vacation.start1 || vacation.start1 >= vacation.end1) {
        vacation.end1 = '';
      }
      if (!vacation.start2 || vacation.start2 >= vacation.end2) {
        vacation.end2 = '';
      }
    }
  }


  validator(rows: Array<any>): boolean {
    const isvalid = rows.filter((e, index) => {
      return (!e.start1 && !e.end1 && !e.start2 && !e.end2) ||
        (e.start1 && e.end1 && !e.start2 && !e.end2) ||
        (e.start1 && e.end1 && e.start2 && e.end2)
    }).length > 0
    return isvalid;
  }

  getCurrentWeek(date, key?: any, payload?: any) {
    moment.locale("fr");
    const start = moment(date).startOf("isoWeeks");
    const end = moment(date).endOf("isoWeeks");
    const diff = end.diff(start, "days") + 1;
    return new Array(diff).fill({}).map((day, i) => {
      const item = moment(start).add(i, "days");
      const dayItem = {
        date: item.format("YYYY-MM-DD"),
        name: item.format('dddd').substring(0, 3),
        day: item.format('DD/MM'),
        isNow: moment().format("YYYY-MM-DD") == item.format('YYYY-MM-DD'),
        isSelected: moment().format("YYYY-MM-DD") == item.format('YYYY-MM-DD'),
        isDisabled: item.isAfter(moment()) || null
      };
      if (key && payload) {
        dayItem[key] = payload;
      }
      return dayItem;
    })
  }

  InPeriods(date, rows: Array<any>) {
    let isInPeriods = rows.find(e => {
      const start = moment(e.start, "YYYY-MM-DD");
      const end = e.end ? moment(e.end, "YYYY-MM-DD") : moment();
      return moment(date).isBetween(start, end, "days", "[]");
    });
    isInPeriods = typeof isInPeriods != "undefined";
    return isInPeriods;
  }

  loadWorker(data, cb) {
    var worker = new Worker("/assets/js/worker.js");
    worker.onmessage = (e) => {
      switch (e.data.t) {
        case 'ready':
          this.onParseFile = "ON_READ";
          break;
        case 'e':
          this.onParseFile = "FAILED";
          break;
        case 'xlsx':
          this.onParseFile = "DONE";
          cb(JSON.parse(e.data.d));
          break;
      }
    };
    worker.postMessage({d: data, b: {type: 'array', raw: true, dateNF: 'YYYY-MM-DD', defval: ''}, t: 'xlsx'});

  }

  readerFile(file, cb) {
    this.file = file;
    var reader = new FileReader();
    reader.onload = (e: any) => {
      var data = e.target.result;
      var readtype = {type: 'array'};
      try {
        this.loadWorker(data, cb);
        return;
      } catch (e) {
        console.log("catch", e);
      }
    };
    reader.readAsArrayBuffer(file);
  }

  parseValueFile(data): ParseFileVO {
    const parseRows = [];
    const rowsIndexError = [];
    const rows = [];
    data.forEach((sheet) => {
      let lengthRows: any = Object.keys(sheet);
      lengthRows = lengthRows.filter(e => !e.includes('!')).pop().replace(/\D+/gm, '')
      lengthRows = parseInt(lengthRows);

      for (let i = 2; i < lengthRows + 1; i++) {
        Object.keys(this.validatiorColumns).forEach((col, index) => {
          const key = `${col}${i}`;
          const {t, v, w} = sheet[key] || {t: null, v: null, w: null};
          const {exec, specs} = this.validatiorColumns[col];
          let required = this.validatiorColumns[col].required;
          const fn: (value: any, t: any, v: any, index: any, key: any, sheet: any, specs: any,required:boolean) => ValidatorErrors = exec;
          const returnFn = fn(w || '', t || '', v || '', i, key, sheet, specs,required);
          let {error, value, message, match, values} = returnFn;
          if ((w && error) || (!w && !v)) {
            if (required)
              rowsIndexError.push(i);
            else if (w)
              rowsIndexError.push(i);
            parseRows.push({col, i, ...returnFn})
          }
          rows.push({col, i, ...returnFn})
        })
      }
    });
    return {
      blocks: [],
      prepareRowsError: [],
      parseRows, rowsIndexError: Array.from(new Set(rowsIndexError)), rows, rowsError: [],
      indexRows: Array.from(new Set(rows.map(e => e.i)))
    };
  }

  groupRows(rows: any[]) {
    const d = rows.reduce(function (r: any, a: any) {
      r[a.i] = r[a.i] || [];
      r[a.i].push(a);
      return r;
    }, Object.create(null));
    return {
      asValues: Object.values(d),
      asKeys: Object.keys(d)
    }
  }

  rowsXlsxToJson(sheet: ParseFileVO) {
    return sheet.indexRows.map(i => {
        const row = sheet.rows.filter(v => v.i == i)
        const username = row.find(e => e.col == "A").value;
        const date = row.find(e => e.col == "B").value;

        const s1 = row.find(e => e.col == "C").value;
        const e1 = row.find(e => e.col == "D").value;

        const s2 = row.find(e => e.col == "E").value;
        const e2 = row.find(e => e.col == "F").value;

        const s3 = row.find(e => e.col == "G").value;
        const e3 = row.find(e => e.col == "H").value;

        const s4 = row.find(e => e.col == "I").value;
        const e4 = row.find(e => e.col == "J").value;

        const _break = 0;//row.find(e => e.col == "H").value;

      const bs1 = row.find(e => e.col == "K").value;
      const be1 = row.find(e => e.col == "L").value;

      const bs2 = row.find(e => e.col == "M").value;
      const be2 = row.find(e => e.col == "N").value;

      const _motif = row.find(e => e.col == "O").value;

        return {
          rowIndex: i,
          username,
          date,
          vacation1: {start: s1, end: e1},
          vacation2: {start: s2, end: e2},
          vacation3: {start: s3, end: e3},
          vacation4: {start: s4, end: e4},
          break1: {start: bs1, end: be1},
          break2: {start: bs2, end: be2},
          breaks: _break,
          motif: _motif
        };
    })
  }
  padUserName(c: string, a: string){
    var b = c.length - a.length;
    return "0".repeat(1>b?0:b)+a
  }

  inHoursBreak() {
    let findMinute = j => j<10?"0"+j:j;
    this.hoursBreak = [];
    for(let i = 0; i < 24; i++){
      for(let j = 0; j < 60; j++){
        let time = i + ":" + findMinute(j);
        if(i < 10){
          time = "0" + time;
        }
        this.hoursBreak.push(time);
      }
    }
  }
}

export class Validatiors {
  protected static formatDate = "YYYY-MM-DD";
  protected static formatHours = "HH:mm:ss";

  protected static rgDate = [
    /[\d]{4,5}-[\d]{2,2}-[\d]{2,2}/gm,
    /[\d]{2,2}\/[\d]{2,2}\/[\d]{4,5}/gm,

  ];
  protected static rgHours = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]?$/gm
  protected static rgNumber = /^\d+/gm

  /**
   * match & Format Date
   * */
  public static Date(value: string, t?: any, v?: any): ValidatorErrors {
    value = value ? value : '';
    value = value.length == 0 ? typeof v == "number" ? Validatiors.intToDateXslx(v) : v : value;
    const match = Validatiors.rgDate.filter(e => {
      const m = (value || '').match(e);
      return m;
    });
    const check = (value && value.length == 10) && match.length > 0;
    const res = check ? moment(value, Validatiors.formatDate).format(Validatiors.formatDate) : value;
    return Validatiors.validator({
      resolve: res,
      rejected: check,
      message: `[${value}] Is not a Date`,
      values: {value, t, v},
      validator: 'DATE'
    })
  }

  /**
   * match & Format hours like  HH:mm:ss
   * */
  public static Hours(value: string, t?: any, v?: any, index?: any, key?: any, sheet?: any, specs?: any, required?: boolean): ValidatorErrors {
    value = value ? value : '';
    value = value.length == 0 ? v : value;

    if (!required && value=='') return Validatiors.validator({
      resolve: null,
      rejected: true,
      message: "",
      values: {value, t, v},
      validator: 'SPECS:BREAK'
    });
    //if (value == '' && !required) return;
    /*    value = moment(value, 'HH:mm:ss').format("HH:mm:ss");
    const match = moment(value, 'HH:mm:ss', true).isValid()*/
    const match = value.match(Validatiors.rgHours)
    const res = match ? moment(value, Validatiors.formatHours).format(Validatiors.formatHours) : value;

    let checkSpec = true;
    let msgSpec = '';
    const m  = moment(value, 'HH:mm:ss')
    if(specs && specs.$between) {
      let [k1, k2] = specs.$between;
      if(k1 && k2) {
        k1 = `${k1}${index}`;
        k2 = `${k2}${index}`;

        let kv1 = sheet[k1]?sheet[k1].w:"";
        let kv2 = sheet[k2]?sheet[k2].w:"";

        const c  = m.isBetween(moment(kv1, 'HH:mm:ss'), moment(kv2, 'HH:mm:ss'));

        if(!c) msgSpec = `[${value}] Is not between [${kv1}, ${kv2}]`
        checkSpec = c;
      }
    }

    if(checkSpec) {
      if(specs && specs.$gt) {
        let mv = [];
        checkSpec = (specs.$gt || []).every(e => {
          const {w} = sheet[`${e}${index}`] || {w: ''};
          const c = m.isAfter(moment(w, 'HH:mm:ss'))
          if(!c) mv.push(w);
          return c;
        })
        if(!checkSpec) msgSpec = `[${value}] Is not After [${mv.join(' ,')}]`
      }
    }

    if(checkSpec) {
      if(specs && specs.$lt) {
        let mv = [];
        checkSpec = (specs.$gt || []).every(e => {
          const {w} = sheet[`${e}${index}`] || {w: ''};
          const c = m.isBefore(moment(w, 'HH:mm:ss'))
          if(!c) mv.push(w);
          return c;
        })
        if(!checkSpec) msgSpec = `[${value}] Is not Before [${mv.join(' ,')}]`
      }
    }
    if(!checkSpec) {

      return Validatiors.validator({
        resolve: res,
        rejected: false,
        message: msgSpec,
        values: {value, t, v},
        validator: 'SPECS:BREAK'
      });
    }


    return Validatiors.validator({
      resolve: res,
      rejected: match || value.length > 0,
      message: `[${value}] Is not Hours hh:mm:ss`,
      values: {value, t, v},
      validator: 'HOURS'
    });
  }

  public static Digit(value: string, t?: any, v?: any): ValidatorErrors {
    value = value ? value : '';
    value = value.length == 0 ? v : value;

    const match = value.match(Validatiors.rgNumber)
    return Validatiors.validator({
      resolve: value,
      rejected: match || value.length > 0,
      message: `[${value}] Is not Digit`,
      values: {value, t, v},
      validator: 'DIGIT'
    });
  }

  public static Default(value: string, t?: any, v?: any): ValidatorErrors {
    value = value ? value : '';
    value = value.length == 0 ? v : value;

    return Validatiors.validator({
      resolve: value,
      rejected: value.length > 0,
      message: `[${value}] Is Empty`,
      values: {value, t, v},
      validator: 'DEFAULT'
    });
  }


  public static validator(option: any): ValidatorErrors {
    const {resolve, rejected, message, values, validator} = option;
    return {error: !rejected, value: resolve, message: !rejected ? message : null, match: rejected, values, validator};
  }


  public static intToDateXslx(date: number) {
    return moment(new Date(Math.round((date - 25569) * 86400 * 1000))).format(Validatiors.formatDate);
  }
}

interface ValidatorErrors {
  error: any;
  value: any;
  message: string,
  match: any;
  values?: any;
  validator: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/injection/BaseComponent.ts